import React from "react";
import PopupWrapper from "../../PopupWrapper";
import { Form, InputGroup } from "react-bootstrap";
import "./docSearch.css";
import { Search, XLg } from "react-bootstrap-icons";

const DocSearchModal = ({
  showDocSearch,
  closeDocSearch,
  setSearchQuery,
  content,
  searchQuery,
}) => {
  function handleSearch(e) {
    setSearchQuery(e.target.value);
  }

  return (
    <>
      <PopupWrapper
        title={
          <h2 className="p-2 font-weight-bold text-dark searchBox">
            <InputGroup className="">
              <InputGroup.Text className="bg-white border-0">
                <Search color="rgb(134, 183, 254)" size={20} />
              </InputGroup.Text>
              <Form.Control
                placeholder="Search docs"
                aria-label="Username"
                aria-describedby="basic-addon1"
                onChange={handleSearch}
                className="border-0 customInput"
                autoFocus
                value={searchQuery}
              />
              {searchQuery?.length ? (
                <InputGroup.Text
                  className="border-0 bg-white"
                  role="button"
                  onClick={() => setSearchQuery("")}
                >
                  <XLg color="rgb(134, 183, 254)" size={20} />
                </InputGroup.Text>
              ) : null}
            </InputGroup>
          </h2>
        }
        Component={content}
        toShow={showDocSearch}
        extraClass={"min-width-50vw"}
        closeEventHandler={() => {
          closeDocSearch();
        }}
        titleClassName={"w-100 p-2 mx-3"}
        bodyStyle={{
          maxHeight: "50vh",
          overflowY: "auto",
          marginBottom: "1rem",
        }}
      />
    </>
  );
};

export default DocSearchModal;
